import { useMutation } from "@tanstack/react-query";
import { apiV2Request, ApiV2RequestScope } from "../apiV2Request";
import { UserRequestPasswordResetEmailRequestType } from "@sellar-io/api-v2/types";

export const useUserPasswordReset = () => {
  return useMutation({
    networkMode: "always",
    retry: false,
    mutationFn: (request: { data: UserRequestPasswordResetEmailRequestType }) =>
      apiV2Request({
        timeout: 15000,
        scope: ApiV2RequestScope.Public,
        method: "POST",
        path: `users/request-password-reset-email`,
        data: request.data,
      }).then((response) => response),
  });
};
